import React from 'react';
import { NavLink } from "react-router-dom";
import CalculatePayments from "../calculation/Calculation.js";
import { createUrlHash } from "../update-parent-window/Updater.js";
import { formatInvestment, roundInvestment } from "../util/formatting.js";
import { isValidPhoneNumber } from "../util/validation.js";
import { config } from "../config";

class ContactForm extends React.Component {
    constructor(props) {
        super(props);
        this.curImpModel = this.props.state.implementationModels.filter((item) => {
            if(item.slug === this.props.state.implementationModel) return item;
            return null;
        });
        this.selectedFundingModels = this.props.state.fundingModels.filter((item) => {
            if(this.props.state.selectedFundings.includes(item.slug)) return item;
            return null;
        }).sort((a, b) => a.order - b.order);
        this.state = {
            formSentAttempted: false,
            formSent: false,
            sendingForm: false,
            curFocus: null,
            selectedFundingModels: this.props.state.selectedFundings
        };
        this.calcs =
          this.selectedFundingModels.map(item => {
            let state = this.props.state;
            return CalculatePayments(item.slug, item.title, state.investmentSize, state.payBackTime, state.completionYear,
                                     state.varsLoanInterest, state.varsGreenLoanInterest, state.varsLeasingInterest,
                                     state.varsLeasingResidualValue, state.varsGreenLeasingInterest,
                                     state.varsGreenLeasingResidualValue, state.varsLongRentInitialRent,
                                     state.varsLongRentIndexing, state.varsLongRentRedemptionValue,
                                     state.varsShortRentInitialRent, state.varsShortRentIndexing,
                                     state.varsShortRentRedemptionValue, state.varsLeasingContractTime,
                                     state.varsGreenLeasingContractTime);
          });
        this.sendForm = this.sendForm.bind(this);
    }

    updateContact(id, e) {
        let curVal = e.target.value;
        this.props.updateState({[id]: curVal});
    }

    sendForm(event) {
      event.preventDefault();
      this.setState({formSentAttempted: true});
      if(!this.checkAllErrors()) {
        let url = config.EMAIL_API;
        let fms = this.selectedFundingModels.filter(fm => this.state.selectedFundingModels.includes(fm.slug))
                      .map(fm => {
                        let calc = this.calcs.filter((c) => {
                            if(c.title === fm.title) return c;
                            return null;
                        });
                        return fm.title + ' ' + formatInvestment(calc[0].sum);
                      });
        this.setState({sendingForm:true});
        fetch(url, {
          method: 'POST',
          headers: new Headers({
            'Content-Type': 'application/json',
            'Origin': config.IFRAME_ORIGIN,
          }),
          body: JSON.stringify({
            'name': this.props.state.contactName,
            'email': this.props.state.contactEmail,
            'phoneNumber': this.props.state.contactPhoneNumber,
            'message': this.props.state.contactMessage,
            'implementationModel': this.curImpModel[0].title,
            'fundingModels': fms.join(', '),
            'investmentSize': formatInvestment(roundToClosest100k(this.props.state.investmentSize * 1000000)),
            'payBackTime': this.props.state.payBackTime,
            'link': config.IFRAME_ORIGIN + "/vertailulaskuri/#" + createUrlHash(this.props.state)
          }),
        }).then(response => {
          if (response.ok) {
            this.setState({formSent: true, sendingForm: false});
            this.props.updateState({contactFormSent: true});
          } else {
            this.setState({formSent:false,sendingForm:false});
          }
        }).catch(data => this.setState({formSent:false,sendingForm:false}));
      }
    }

    validateEmail(email) {
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    handlePhoneNumberValidation(phoneNumber) {
        if (!phoneNumber || phoneNumber === "") {
            return true;
        }

        return isValidPhoneNumber(phoneNumber)
    }

    checkAllErrors() {
        if (!this.checkErrors("contactName") &&
            !this.checkErrors("contactEmail") &&
            !this.checkErrors("contactPhoneNumber") &&
            !this.checkErrors("selectedFundingModels")) {
            return false;
        }
        return true;
    }

    checkErrors(id) {
        switch(id) {
            case "contactName":
                if(!this.props.state[id] || !this.props.state[id].length) return "Pakollinen kenttä";
                return false;
            case "contactEmail":
                if(!this.props.state[id] || !this.props.state[id].length) return "Pakollinen kenttä";
                if(!this.validateEmail(this.props.state.contactEmail)) return "Virheellinen sähköposti";
                return false;
            case "contactPhoneNumber":
                if(!this.handlePhoneNumberValidation(this.props.state.contactPhoneNumber)) {
                    return "Virheellinen puhelinnumero";
                }
                return false;
            case "selectedFundingModels":
                if(!this.state[id].length) return "Valitse vähintään yksi";
                return false;
            default:
                return false;
        }
    }

    handleCheckboxClick(e) {
        let curVal = e.target.value,
            selected = this.state.selectedFundingModels;
        if(selected.includes(curVal)) {
            selected = selected.filter(item => item !== curVal);
        } else {
            selected.push(curVal);
        }
        this.setState({selectedFundingModels: selected});
    }

    renderFundingModelSelections() {
        let curFundModels = [];
        this.selectedFundingModels.forEach((item,index) => {
            let calc = this.calcs.filter((c) => {
                if(c.title === item.title) return c;
                return null;
            });
            curFundModels.push(
                <div className="fund-model-item" key={"contact-fund-model-"+item.slug}>
                    <div className="col-left">
                        <label className={"contact-form__item select"+(this.state.selectedFundingModels.includes(item.slug) ? " selected" : "")}>
                            <span className="select__title">{item.title}</span>
                            <span className="select__description">{item.description}</span>
                            <input
                                type="checkbox"
                                value={item.slug}
                                onChange={(e) => {this.handleCheckboxClick(e)}} />
                        </label>
                    </div>
                    <div className="col-right">
                        Pääomakustannukset
                        <span>
                            {calc[0].sum.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1 ")} €
                        </span>
                    </div>
                </div>
            );
        });
        return curFundModels;
    }

    checkIfButtonDisabled() {
        if (this.state.sendingForm ||
            (!this.props.state.contactName || !this.props.state.contactName.length) ||
            (!this.props.state.contactEmail || !this.props.state.contactEmail.length) ||
            !this.state.selectedFundingModels.length) return "disabled";
        return null;
    }

    render() {
        if(this.state.formSent) {
            return (
                <div className="card-wrapper form-sent-message">
                    <h2>Viesti lähetetty</h2>
                    <p>Kiitos yhteydenotostasi. Olemme yhteydessä sinuun mahdollisimman pian.</p>
                    <p><NavLink to="/phase3" exact>Palaa vertailuun</NavLink></p>
                </div>
            );
        } else {

            return (
                <form
                    className={
                        "contact-form"+(this.state.formSentAttempted ? " contact-form--sent" : "")+
                        (this.checkAllErrors() ? " contact-form--errors" : "")
                    }>
                    <div className="card-wrapper">
                        <div className="contact-form__section">
                            <h4>Toteutustapa</h4>
                            <label className="contact-form__item select selected disabled">
                                <span className="select__title">{this.curImpModel[0].title}</span>
                                <span className="select__description">{this.curImpModel[0].description}</span>
                                <input
                                    type="checkbox"
                                    checked="checked"
                                    readOnly={true}
                                    disabled="disabled" />
                            </label>
                        </div>
                        <div
                            className="contact-form__section contact-form__section--funding">
                            <h4 className={
                                "funding-models-title"+
                                (this.checkErrors('selectedFundingModels') ? " error" : "")
                            }>
                                Valitse rahoitusmalli *
                                <span className="error-message">{this.checkErrors('selectedFundingModels')}</span>
                            </h4>
                            {this.renderFundingModelSelections()}
                        </div>
                        <div className="contact-form__section">
                            <h4>Yhteystiedot</h4>
                            <p className="contact-form__item">Ota yhteyttä Kuntarahoituksen asiantuntijoihin, niin löydämme sinulle parhaan ratkaisun.</p>
                            <label
                                className={
                                    "contact-form__item"+
                                    (this.state.curFocus === "contactName" ? " focus" : "")+
                                    (this.checkErrors('contactName') ? " error" : "")
                                }
                                htmlFor="contactName">
                                <span>
                                    Nimi (Pakollinen)
                                    <span className="error-message">{this.checkErrors('contactName')}</span>
                                </span>
                                <input
                                    type="text"
                                    className="contact-form__text-input"
                                    id="contactName"
                                    onFocus={() => {this.setState({curFocus:"contactName"})}}
                                    onBlur={() => {this.setState({curFocus:null})}}
                                    onChange={this.updateContact.bind(this, "contactName")}
                                    disabled={this.state.sendingForm ? "disabled" : null}
                                    value={this.props.state.contactName ? this.props.state.contactName : ""}
                                    maxLength="50" />
                            </label>
                            <label
                                className={
                                    "contact-form__item"+
                                    (this.state.curFocus === "contactEmail" ? " focus" : "")+
                                    (this.checkErrors('contactEmail') ? " error" : "")
                                }
                                htmlFor="contactEmail">
                                <span>
                                    Sähköposti (Pakollinen)
                                    <span className="error-message">{this.checkErrors('contactEmail')}</span>
                                </span>
                                <input
                                    type="text"
                                    className="contact-form__text-input"
                                    id="contactEmail"
                                    onFocus={() => {this.setState({curFocus:"contactEmail"})}}
                                    onBlur={() => {this.setState({curFocus:null})}}
                                    onChange={this.updateContact.bind(this, "contactEmail")}
                                    disabled={this.state.sendingForm ? "disabled" : null}
                                    value={this.props.state.contactEmail ? this.props.state.contactEmail : ""}
                                    maxLength="50" />
                            </label>
                            <label
                                className={
                                    "contact-form__item"+
                                    (this.state.curFocus === "contactPhoneNumber" ? " focus" : "")+
                                    (this.checkErrors('contactPhoneNumber') ? " error" : "")
                                }
                                htmlFor="contactPhoneNumber">
                                <span>
                                    Puhelinnumero
                                    <span className="error-message">{this.checkErrors('contactPhoneNumber')}</span>
                                </span>
                                <input
                                    type="text"
                                    className="contact-form__text-input"
                                    id="contactPhoneNumber"
                                    onFocus={() => {this.setState({curFocus:"contactPhoneNumber"})}}
                                    onBlur={() => {this.setState({curFocus:null})}}
                                    onChange={this.updateContact.bind(this, "contactPhoneNumber")}
                                    disabled={this.state.sendingForm ? "disabled" : null}
                                    value={this.props.state.contactPhoneNumber ? this.props.state.contactPhoneNumber : ""}
                                    maxLength="50" />
                            </label>
                            <label
                                className={"contact-form__item"+(this.state.curFocus === "contactMessage" ? " focus" : "")}
                                htmlFor="contactMessage">
                                <span>Viesti</span>
                                <textarea
                                    className="contact-form__textarea"
                                    id="contactMessage"
                                    onFocus={() => {this.setState({curFocus:"contactMessage"})}}
                                    onBlur={() => {this.setState({curFocus:null})}}
                                    onChange={this.updateContact.bind(this, "contactMessage")}
                                    disabled={this.state.sendingForm ? "disabled" : null}
                                    value={this.props.state.contactMessage ? this.props.state.contactMessage : ""}
                                    maxLength="1200"></textarea>
                            </label>
                            <div className="contact-form__item contact-form__send-wrapper">
                                <div className="error-message-general">Lomakkeessa on virheitä</div>
                                <button
                                    type="submit"
                                    className={"contact-form__send"+(this.state.sendingForm ? " contact-form__send--sending" : "")}
                                    disabled={this.checkIfButtonDisabled()}
                                    onClick={this.sendForm}>
                                        Lähetä
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            );
        }
    }
}

export default ContactForm;

const roundToClosest100k = roundInvestment(100000);
